const SvgIcon = (props) => {
  switch (props.name) {
    case "one":
      return (
        <svg
          width={70}
          height={73}
          viewBox="0 0 70 73"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <g filter="url(#filter0_d_9465_3568)">
            <rect x={5} width={60} height={60} rx={6} fill="#222" shapeRendering="crispEdges" />
            <path
              d="M35 39.217c-3.65 0-6.975-1.02-9.975-3.056-3-2.038-5.175-4.769-6.525-8.193 1.35-3.425 3.525-6.156 6.525-8.193 3-2.038 6.325-3.056 9.975-3.056 3.65 0 6.975 1.018 9.975 3.056 3 2.037 5.175 4.768 6.525 8.193-.15.375-.306.737-.469 1.087a9.79 9.79 0 01-.544 1.012l-2.362-2.212c-1.275-2.5-3.081-4.48-5.419-5.943C40.37 20.45 37.8 19.718 35 19.718c-2.825 0-5.419.744-7.781 2.232-2.363 1.487-4.169 3.493-5.419 6.018 1.25 2.524 3.056 4.53 5.419 6.018 2.362 1.487 4.956 2.23 7.781 2.23.275 0 .544-.005.806-.018.263-.012.532-.044.806-.094-.1.5-.15 1.013-.15 1.538 0 .525.05 1.037.15 1.537a8.904 8.904 0 01-.806.038H35zm0-4.5c-1.875 0-3.469-.656-4.781-1.969-1.313-1.312-1.969-2.905-1.969-4.78 0-1.875.656-3.469 1.969-4.781 1.312-1.313 2.906-1.969 4.781-1.969 1.875 0 3.469.657 4.781 1.969 1.313 1.312 1.969 2.906 1.969 4.78a6.653 6.653 0 01-.075 1.013l-2.325 2.137c-.475.475-.9.982-1.275 1.519a9.075 9.075 0 00-.938 1.706 6.176 6.176 0 01-2.138.375z"
              fill="#DEDEDE"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M39.938 41.316l1.96 1.96 3.6-3.6 3.6 3.6 1.96-1.96-3.6-3.6 3.6-3.6-1.96-1.96-3.6 3.6-3.6-3.6-1.96 1.96 3.6 3.6-3.6 3.6z"
              fill="#6C8EF8"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_9465_3568"
              x={0.8}
              y={0}
              width={68.4}
              height={72.6}
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy={8.4} />
              <feGaussianBlur stdDeviation={2.1} />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
              <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_9465_3568" />
              <feBlend in="SourceGraphic" in2="effect1_dropShadow_9465_3568" result="shape" />
            </filter>
          </defs>
        </svg>
      );
    case "two":
      return (
        <svg
          width={70}
          height={73}
          viewBox="0 0 70 73"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <g filter="url(#filter0_d_9465_3584)">
            <rect x={5} width={60} height={60} rx={6} fill="#222" shapeRendering="crispEdges" />
            <path
              d="M44.75 37.5a2.17 2.17 0 001.594-.657A2.17 2.17 0 0047 35.25a2.17 2.17 0 00-.656-1.593A2.17 2.17 0 0044.75 33a2.17 2.17 0 00-1.594.656 2.17 2.17 0 00-.656 1.593c0 .625.219 1.157.656 1.594a2.17 2.17 0 001.594.656zm0 4.499c.775 0 1.487-.181 2.138-.544a4.486 4.486 0 001.575-1.444 7.337 7.337 0 00-1.763-.75A7.198 7.198 0 0044.75 39c-.675 0-1.325.088-1.95.263a7.337 7.337 0 00-1.762.75c.4.6.925 1.08 1.575 1.443.65.363 1.362.544 2.137.544zm0 3c-2.075 0-3.844-.732-5.306-2.194-1.463-1.462-2.194-3.23-2.194-5.306 0-2.075.731-3.843 2.194-5.306C40.906 30.732 42.675 30 44.75 30s3.844.731 5.306 2.194c1.463 1.462 2.194 3.23 2.194 5.305 0 2.075-.731 3.844-2.194 5.306-1.462 1.462-3.231 2.194-5.306 2.194z"
              fill="#6C8EF8"
            />
            <path
              d="M40.813 25.236C38.187 26.412 35 27 31.25 27c-3.75 0-6.938-.588-9.563-1.762-2.625-1.175-3.937-2.588-3.937-4.238 0-1.65 1.313-3.062 3.938-4.237C24.313 15.587 27.5 15 31.25 15c3.75 0 6.938.587 9.563 1.762C43.437 17.937 44.75 19.35 44.75 21c0 1.65-1.313 3.063-3.938 4.238zM35.094 30.43c-1.538.212-2.819.318-3.844.318s-2.306-.106-3.844-.318a24.733 24.733 0 01-4.444-1.031c-1.424-.475-2.65-1.094-3.674-1.857-1.026-.762-1.538-1.693-1.538-2.793v3.75c0 1.1.512 2.03 1.538 2.793 1.024.763 2.25 1.381 3.674 1.856 1.425.475 2.907.819 4.444 1.031 1.538.213 2.819.32 3.844.32.952 0 2.126-.093 3.52-.276a10.5 10.5 0 012.626-4.22c-.753.177-1.52.319-2.302.427zM34.264 38.036c.065 1.288.362 2.515.85 3.64-.007 0-.013.002-.02.003-1.538.212-2.819.318-3.844.318s-2.306-.106-3.844-.318a24.733 24.733 0 01-4.444-1.032c-1.424-.474-2.65-1.093-3.674-1.856-1.026-.762-1.538-1.693-1.538-2.793v-3.75c0 1.1.512 2.031 1.538 2.794 1.024.762 2.25 1.38 3.674 1.856 1.425.475 2.907.819 4.444 1.031 1.538.212 2.819.319 3.844.319.835 0 1.84-.07 3.014-.212z"
              fill="#DEDEDE"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_9465_3584"
              x={0.8}
              y={0}
              width={68.4}
              height={72.6}
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy={8.4} />
              <feGaussianBlur stdDeviation={2.1} />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
              <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_9465_3584" />
              <feBlend in="SourceGraphic" in2="effect1_dropShadow_9465_3584" result="shape" />
            </filter>
          </defs>
        </svg>
      );
    case "three":
      return (
        <svg
          width={70}
          height={73}
          viewBox="0 0 70 73"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <g filter="url(#filter0_d_9465_3576)">
            <rect x={5} width={60} height={60} rx={6} fill="#222" shapeRendering="crispEdges" />
            <path
              d="M23 44.247a2.889 2.889 0 01-2.119-.881A2.888 2.888 0 0120 41.248v-6h10.5v3h9v-3H50v6c0 .824-.294 1.53-.881 2.118a2.889 2.889 0 01-2.119.881H23z"
              fill="#6C8EF8"
            />
            <path
              d="M33.5 32.248v3h3v-3h-3zM20 24.75v7.498h10.5v-3h9v3H50V24.75c0-.825-.294-1.531-.881-2.118A2.889 2.889 0 0047 21.749h-6v-3c0-.824-.294-1.53-.881-2.118A2.889 2.889 0 0038 15.75h-6c-.825 0-1.531.294-2.119.881A2.888 2.888 0 0029 18.75v3h-6c-.825 0-1.531.293-2.119.88A2.888 2.888 0 0020 24.75z"
              fill="#DEDEDE"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_9465_3576"
              x={0.8}
              y={0}
              width={68.4}
              height={72.6}
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy={8.4} />
              <feGaussianBlur stdDeviation={2.1} />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
              <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_9465_3576" />
              <feBlend in="SourceGraphic" in2="effect1_dropShadow_9465_3576" result="shape" />
            </filter>
          </defs>
        </svg>
      );
    case "four":
      return (
        <svg
          width={70}
          height={73}
          viewBox="0 0 70 73"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <g filter="url(#filter0_d_9465_3593)">
            <rect x={5} width={60} height={60} rx={6} fill="#222" shapeRendering="crispEdges" />
            <path
              d="M48.444 25.563L39.37 16.49l.638-.637c.575-.575 1.288-.856 2.138-.844.85.013 1.562.306 2.137.881l4.838 4.837c.575.575.862 1.282.862 2.119 0 .837-.288 1.544-.862 2.119l-.675.6zM29.957 44.124c-.575.575-1.281.862-2.119.862-.837 0-1.544-.287-2.119-.862l-4.837-4.837c-.575-.575-.863-1.281-.863-2.118 0-.838.288-1.544.863-2.119l.6-.6 9.075 9.074-.6.6z"
              fill="#6C8EF8"
            />
            <path
              d="M34.347 43.535c.4 0 .75-.15 1.05-.45l2.175-2.137c.3-.3.45-.657.45-1.07 0-.411-.15-.768-.45-1.068l-2.363-2.362 6.225-6.224 2.363 2.362c.3.3.65.45 1.05.45s.75-.15 1.05-.45l2.175-2.137c.3-.3.45-.657.45-1.069 0-.412-.15-.769-.45-1.069L36.709 16.95c-.3-.3-.656-.45-1.068-.45-.413 0-.77.15-1.07.45l-2.137 2.175c-.3.3-.45.65-.45 1.05s.15.75.45 1.05l2.363 2.362-6.225 6.224-2.363-2.362c-.3-.3-.656-.45-1.068-.45-.413 0-.77.15-1.07.45l-2.137 2.175c-.3.3-.45.65-.45 1.05s.15.75.45 1.05l11.363 11.36c.3.3.65.45 1.05.45z"
              fill="#DEDEDE"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_9465_3593"
              x={0.8}
              y={0}
              width={68.4}
              height={72.6}
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy={8.4} />
              <feGaussianBlur stdDeviation={2.1} />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
              <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_9465_3593" />
              <feBlend in="SourceGraphic" in2="effect1_dropShadow_9465_3593" result="shape" />
            </filter>
          </defs>
        </svg>
      );
    case "five":
      return (
        <svg
          width={70}
          height={73}
          viewBox="0 0 70 73"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <g filter="url(#filter0_d_9465_3605)">
            <rect x={5} width={60} height={60} rx={6} fill="#222" shapeRendering="crispEdges" />
            <path
              d="M23.41 44.997v-8.181h3.41v-1.134h2.727v1.134h3.409v8.181H23.41zM29.547 24.28h-2.728V23.18H23.41V15h9.546v8.181h-3.41v1.099zM34.587 31.362v-2.727h2.46v-2.727h9.545v8.181h-9.545v-2.727h-2.46z"
              fill="#DEDEDE"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M32.917 34.009H23.41v-8.064h9.507v8.064zm-6.364-.984l-1.374-1.373 1.637-1.636-1.637-1.636 1.374-1.373 1.636 1.636 1.637-1.637 1.373 1.374-1.637 1.636 1.637 1.636-1.373 1.373-1.637-1.636-1.636 1.636z"
              fill="#6C8EF8"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_9465_3605"
              x={0.8}
              y={0}
              width={68.4}
              height={72.6}
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy={8.4} />
              <feGaussianBlur stdDeviation={2.1} />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
              <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_9465_3605" />
              <feBlend in="SourceGraphic" in2="effect1_dropShadow_9465_3605" result="shape" />
            </filter>
          </defs>
        </svg>
      );
    case "six":
      return (
        <svg
          width={70}
          height={73}
          viewBox="0 0 70 73"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <g filter="url(#filter0_d_9465_3613)">
            <rect x={5} width={60} height={60} rx={6} fill="#222" shapeRendering="crispEdges" />
            <path
              d="M27.125 41.248v-6.75h-9V18.75h4.5v11.249h4.5V18.75h4.5v11.249h2.25v4.5h-2.25v6.749h-4.5z"
              fill="#6C8EF8"
            />
            <path
              d="M42.875 41.248v-6.75h-4.5V18.75h4.5v11.249h4.5V18.75h4.5v15.748h-4.5v6.75h-4.5z"
              fill="#DEDEDE"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_9465_3613"
              x={0.8}
              y={0}
              width={68.4}
              height={72.6}
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity={0} result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy={8.4} />
              <feGaussianBlur stdDeviation={2.1} />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
              <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_9465_3613" />
              <feBlend in="SourceGraphic" in2="effect1_dropShadow_9465_3613" result="shape" />
            </filter>
          </defs>
        </svg>
      );

    default:
      return (
        <svg
          width="47"
          height="48"
          viewBox="0 0 47 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect y="0.775391" width="20.7839" height="20.7839" rx="2.36181" fill="#B8C3E9" />
          <rect y="26.9922" width="20.7839" height="20.7839" rx="2.36181" fill="#6C8EF8" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M35.6132 26.9922C33.9692 26.9922 32.6365 28.3249 32.6365 29.9689V34.4079L28.1984 34.4079C26.5544 34.4079 25.2217 35.7406 25.2217 37.3846C25.2217 39.0286 26.5544 40.3613 28.1984 40.3613H32.6365V44.7994C32.6365 46.4434 33.9692 47.7761 35.6132 47.7761C37.2572 47.7761 38.5899 46.4434 38.5899 44.7994V40.3613H43.0289C44.6729 40.3613 46.0056 39.0286 46.0056 37.3846C46.0056 35.7406 44.6729 34.4079 43.0289 34.4079L38.5899 34.4079V29.9689C38.5899 28.3249 37.2572 26.9922 35.6132 26.9922Z"
            fill="#B8C3E9"
          />
          <rect
            x="25.2227"
            y="0.775391"
            width="20.7839"
            height="20.7839"
            rx="2.36181"
            fill="#6C8EF8"
          />
        </svg>
      );
  }
};

export default SvgIcon;
